import { isCanceledError } from '../../services/utils/apiErrorUtils';

/**
 * Gerencia cancelamento real (via AbortController) de chamadas HTTP disparadas em sequência
 * pelo mesmo "slot" lógico (ex.: `loadContracts`), evitando que requests antigas continuem
 * em voo no browser/servidor enquanto a UI já avançou para outra chamada mais recente.
 */
export class AbortableRequestManager {
  private controller: AbortController | null = null;

  /**
   * Aborta a chamada anterior (se houver) e retorna o signal da nova chamada.
   * Deve ser invocado imediatamente antes de disparar a requisição HTTP.
   */
  start(): AbortSignal {
    this.controller?.abort();
    this.controller = new AbortController();
    return this.controller.signal;
  }

  /** True quando `signal` ainda é o da chamada mais recente (nenhuma outra a substituiu). */
  isCurrent(signal: AbortSignal): boolean {
    return this.controller?.signal === signal;
  }

  /** Cancela a chamada em voo sem iniciar uma nova (ex.: cleanup de unmount). */
  abortCurrent(): void {
    this.controller?.abort();
  }
}

/**
 * Identifica erros originados de cancelamento (nosso próprio AbortController), que não devem
 * ser tratados como falha real: sem toast de erro, sem log ruidoso, sem alterar loading indevidamente.
 *
 * Alias de `isCanceledError` (services/utils/apiErrorUtils) — predicado único e canônico para
 * detectar cancelamento em toda a app, evitando duas implementações divergindo com o tempo.
 */
export const isCancelError = isCanceledError;
